// Display statistics only. Neither roster Elo nor prediction inputs are modified.
export const OLYMPIAD_AGE_YEAR = 2026;
export function olympiadRosterStatistics(roster = [], expectedCount = roster.length) {
  const ratings = roster.map(p => Number(p.rating_used)).filter(r => Number.isFinite(r) && r > 0);
  const ages = roster.map(p => Number(p.birth_year || String(p.birth_date || '').slice(0,4)))
    .filter(y => Number.isInteger(y) && y > 1900 && y <= OLYMPIAD_AGE_YEAR).map(y => OLYMPIAD_AGE_YEAR - y);
  return {
    count: expectedCount, rated: ratings.length, knownAges: ages.length,
    elo: ratings.length ? ratings.reduce((a,b)=>a+b,0)/ratings.length : null,
    age: ages.length === expectedCount && expectedCount > 0 ? ages.reduce((a,b)=>a+b,0)/expectedCount : null,
  };
}
export function placementBins(places, width = 10) {
  return Array.from({length:Math.ceil(places.length/width)},(_,i)=>({
    label: `${i*width+1}–${Math.min(places.length,(i+1)*width)}`,
    count:places.slice(i*width,(i+1)*width).reduce((a,b)=>a+b,0),
  }));
}
